import axios from "axios";
import APIURL from "../../../Main/apiurl";

const add_supplier_balance = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const response = await axios.post(`${APIURL}/add-supplier-balance`, data, config);
    return response?.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

const get_supplier_balance_logs = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const response = await axios.post(`${APIURL}/get-supplier-balance-logs`, data, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return response?.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

const get_supplier_balance_summary = async (params) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const response = await axios.post(`${APIURL}/get-supplier-balance-summary`, params, config);

    if (response?.data?.status_code === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return response?.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

export {
  add_supplier_balance,
  get_supplier_balance_logs,
  get_supplier_balance_summary,
};